// extracted by mini-css-extract-plugin
module.exports = {"tabs":"MainTabsPage_tabs__2IBRL","refreshbtn":"MainTabsPage_refreshbtn__2vAN4"};